const cookieBar = document.querySelector('.js-cookie-bar');
const changePreferencesToggles = document.querySelectorAll('.js-change-preferences');

function togglePreferences() {
  document.body.classList.add('disable-scroll-mobile');
  cookieBar.classList.add('show-preferences');
}

if (cookieBar && changePreferencesToggles.length > 0) {
  changePreferencesToggles.forEach((toggle) => toggle.addEventListener('click', togglePreferences));
}